var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.25,
    height: 13.25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9056 9.97119C18.9056 14.811 14.9043 18.8123 10.0736 18.8123C5.24284 18.8123 1.23242 14.811 1.23242 9.97119C1.23242 5.14046 5.23372 1.13916 10.0645 1.13916C14.8952 1.13916 18.9056 5.14046 18.9056 9.97119ZM2.81836 9.97119C2.81836 14.009 6.04492 17.2355 10.0736 17.2355C14.1022 17.2355 17.347 14.009 17.3379 9.97119C17.3288 5.94255 14.0931 2.70687 10.0645 2.70687C6.03581 2.70687 2.81836 5.94255 2.81836 9.97119ZM10.0007 6.95426C10.6387 6.95426 11.14 6.44385 11.14 5.81494C11.14 5.16781 10.6387 4.6665 10.0007 4.6665C9.37175 4.6665 8.86133 5.16781 8.86133 5.81494C8.86133 6.44385 9.37175 6.95426 10.0007 6.95426ZM12.7168 14.0636C12.7168 14.4373 12.4251 14.7017 12.0605 14.7017H8.55143C8.19596 14.7017 7.9043 14.4373 7.9043 14.0636C7.9043 13.7173 8.19596 13.4438 8.55143 13.4438H9.60872V9.61572H8.70638C8.3418 9.61572 8.05924 9.3514 8.05924 8.9777C8.05924 8.63135 8.3418 8.35791 8.70638 8.35791H10.3379C10.7845 8.35791 11.0306 8.67692 11.0306 9.15999V13.4438H12.0605C12.4251 13.4438 12.7168 13.7173 12.7168 14.0636Z",
    fill: "#212842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.e51b3b89.svg";
export { ForwardRef as ReactComponent };